import {ICode, IName} from './interfaces/util';


export interface ICountry extends ICode, IName {
}

const countries: ICountry[] = [
  {code: 'AD', name: 'Andorra'},
  {code: 'AE', name: 'Vereinigte Arabische Emirate'},
  {code: 'AF', name: 'Afghanistan'},
  {code: 'AG', name: 'Antigua und Barbuda'},
  {code: 'AI', name: 'Anguilla'},
  {code: 'AL', name: 'Albanien'},
  {code: 'AM', name: 'Armenien'},
  {code: 'AO', name: 'Angola'},
  {code: 'AQ', name: 'Antarktis'},
  {code: 'AR', name: 'Argentinien'},
  {code: 'AS', name: 'Samoa'},
  {code: 'AT', name: 'Österreich'},
  {code: 'AU', name: 'Australien'},
  {code: 'AW', name: 'Aruba'},
  {code: 'AX', name: 'Ålandinseln'},
  {code: 'AZ', name: 'Aserbaidschan'},
  {code: 'BA', name: 'Bosnien-Herzegowina'},
  {code: 'BB', name: 'Barbados'},
  {code: 'BD', name: 'Bangladesh'},
  {code: 'BE', name: 'Belgien'},
  {code: 'BF', name: 'Burkina Faso'},
  {code: 'BG', name: 'Bulgarien'},
  {code: 'BH', name: 'Bahrain'},
  {code: 'BI', name: 'Burundi'},
  {code: 'BJ', name: 'Benin'},
  {code: 'BL', name: 'Saint Barthélemy'},
  {code: 'BM', name: 'Bermudas'},
  {code: 'BN', name: 'Brunei'},
  {code: 'BO', name: 'Bolivien'},
  {code: 'BQ', name: 'Bonaire'},
  {code: 'BR', name: 'Brasilien'},
  {code: 'BS', name: 'Bahamas'},
  {code: 'BT', name: 'Bhutan'},
  {code: 'BV', name: 'Bouvet Inseln'},
  {code: 'BW', name: 'Botswana'},
  {code: 'BY', name: 'Weissrussland'},
  {code: 'BZ', name: 'Belize'},
  {code: 'CA', name: 'Kanada'},
  {code: 'CC', name: 'Kokosinseln'},
  {code: 'CD', name: 'Demokratische Republik Kongo'},
  {code: 'CF', name: 'Zentralafrikanische Republik'},
  {code: 'CG', name: 'Kongo'},
  {code: 'CH', name: 'Schweiz'},
  {code: 'CI', name: 'Elfenbeinküste'},
  {code: 'CK', name: 'Cook Inseln'},
  {code: 'CL', name: 'Chile'},
  {code: 'CM', name: 'Kamerun'},
  {code: 'CN', name: 'China'},
  {code: 'CO', name: 'Kolumbien'},
  {code: 'CR', name: 'Costa Rica'},
  {code: 'CU', name: 'Kuba'},
  {code: 'CV', name: 'Kap Verde'},
  {code: 'CW', name: 'Curaçao'},
  {code: 'CX', name: 'Weihnachtsinsel'},
  {code: 'CY', name: 'Zypern'},
  {code: 'CZ', name: 'Tschechische Republik'},
  {code: 'DE', name: 'Deutschland'},
  {code: 'DJ', name: 'Djibuti'},
  {code: 'DK', name: 'Dänemark'},
  {code: 'DM', name: 'Dominika'},
  {code: 'DO', name: 'Dominikanische Republik'},
  {code: 'DZ', name: 'Algerien'},
  {code: 'EC', name: 'Ecuador'},
  {code: 'EE', name: 'Estland'},
  {code: 'EG', name: 'Ägypten'},
  {code: 'EH', name: 'Westsahara'},
  {code: 'ER', name: 'Eritrea'},
  {code: 'ES', name: 'Spanien'},
  {code: 'ET', name: 'Äthiopien'},
  {code: 'FI', name: 'Finnland'},
  {code: 'FJ', name: 'Fidschi'},
  {code: 'FK', name: 'Falkland Inseln'},
  {code: 'FM', name: 'Mikronesien'},
  {code: 'FO', name: 'Färöer Inseln'},
  {code: 'FR', name: 'Frankreich'},
  {code: 'GA', name: 'Gabun'},
  {code: 'GB', name: 'Großbritannien'},
  {code: 'GD', name: 'Grenada'},
  {code: 'GE', name: 'Georgien'},
  {code: 'GF', name: 'französisch Guyana'},
  {code: 'GG', name: 'Guernsey'},
  {code: 'GH', name: 'Ghana'},
  {code: 'GI', name: 'Gibraltar'},
  {code: 'GL', name: 'Grönland'},
  {code: 'GM', name: 'Gambia'},
  {code: 'GN', name: 'Guinea'},
  {code: 'GP', name: 'Guadeloupe'},
  {code: 'GQ', name: 'Äquatorial Guinea'},
  {code: 'GR', name: 'Griechenland'},
  {code: 'GS', name: 'South Georgia, South Sandwich Isl.'},
  {code: 'GT', name: 'Guatemala'},
  {code: 'GU', name: 'Guam'},
  {code: 'GW', name: 'Guinea Bissau'},
  {code: 'GY', name: 'Guyana'},
  {code: 'HK', name: 'Hong Kong'},
  {code: 'HM', name: 'Heard und McDonald Islands'},
  {code: 'HN', name: 'Honduras'},
  {code: 'HR', name: 'Kroatien'},
  {code: 'HT', name: 'Haiti'},
  {code: 'HU', name: 'Ungarn'},
  {code: 'ID', name: 'Indonesien'},
  {code: 'IE', name: 'Irland'},
  {code: 'IL', name: 'Israel'},
  {code: 'IM', name: 'Isle of Man'},
  {code: 'IN', name: 'Indien'},
  {code: 'IO', name: 'Britisch-Indischer Ozean'},
  {code: 'IQ', name: 'Irak'},
  {code: 'IR', name: 'Iran'},
  {code: 'IS', name: 'Island'},
  {code: 'IT', name: 'Italien'},
  {code: 'JE', name: 'Jersey'},
  {code: 'JM', name: 'Jamaika'},
  {code: 'JO', name: 'Jordanien'},
  {code: 'JP', name: 'Japan'},
  {code: 'KE', name: 'Kenia'},
  {code: 'KG', name: 'Kirgisistan'},
  {code: 'KH', name: 'Kambodscha'},
  {code: 'KI', name: 'Kiribati'},
  {code: 'KM', name: 'Komoren'},
  {code: 'KN', name: 'St. Kitts Nevis Anguilla'},
  {code: 'KP', name: 'Nord Korea'},
  {code: 'KR', name: 'Süd Korea'},
  {code: 'KW', name: 'Kuwait'},
  {code: 'KY', name: 'Kaiman Inseln'},
  {code: 'KZ', name: 'Kasachstan'},
  {code: 'LA', name: 'Laos'},
  {code: 'LB', name: 'Libanon'},
  {code: 'LC', name: 'Saint Lucia'},
  {code: 'LI', name: 'Liechtenstein'},
  {code: 'LK', name: 'Sri Lanka'},
  {code: 'LR', name: 'Liberia'},
  {code: 'LS', name: 'Lesotho'},
  {code: 'LT', name: 'Litauen'},
  {code: 'LU', name: 'Luxemburg'},
  {code: 'LV', name: 'Lettland'},
  {code: 'LY', name: 'Libyen'},
  {code: 'MA', name: 'Marokko'},
  {code: 'MC', name: 'Monaco'},
  {code: 'MD', name: 'Moldavien'},
  {code: 'ME', name: 'Montenegro'},
  {code: 'MF', name: 'Saint Martin (franz.)'},
  {code: 'MG', name: 'Madagaskar'},
  {code: 'MH', name: 'Marshall Inseln'},
  {code: 'MK', name: 'Mazedonien'},
  {code: 'ML', name: 'Mali'},
  {code: 'MM', name: 'Myanmar'},
  {code: 'MN', name: 'Mongolei'},
  {code: 'MO', name: 'Macao'},
  {code: 'MP', name: 'Nördliche Marianen'},
  {code: 'MQ', name: 'Martinique'},
  {code: 'MR', name: 'Mauretanien'},
  {code: 'MS', name: 'Montserrat'},
  {code: 'MT', name: 'Malta'},
  {code: 'MU', name: 'Mauritius'},
  {code: 'MV', name: 'Malediven'},
  {code: 'MW', name: 'Malawi'},
  {code: 'MX', name: 'Mexiko'},
  {code: 'MY', name: 'Malaysia'},
  {code: 'MZ', name: 'Mosambik'},
  {code: 'NA', name: 'Namibia'},
  {code: 'NC', name: 'Neukaledonien'},
  {code: 'NE', name: 'Niger'},
  {code: 'NF', name: 'Norfolk Inseln'},
  {code: 'NG', name: 'Nigeria'},
  {code: 'NI', name: 'Nicaragua'},
  {code: 'NL', name: 'Niederlande'},
  {code: 'NO', name: 'Norwegen'},
  {code: 'NP', name: 'Nepal'},
  {code: 'NR', name: 'Nauru'},
  {code: 'NU', name: 'Niue'},
  {code: 'NZ', name: 'Neuseeland'},
  {code: 'OM', name: 'Oman'},
  {code: 'PA', name: 'Panama'},
  {code: 'PE', name: 'Peru'},
  {code: 'PF', name: 'Französisch Polynesien'},
  {code: 'PG', name: 'Papua Neuguinea'},
  {code: 'PH', name: 'Philippinen'},
  {code: 'PK', name: 'Pakistan'},
  {code: 'PL', name: 'Polen'},
  {code: 'PM', name: 'St. Pierre und Miquelon'},
  {code: 'PN', name: 'Pitcairn'},
  {code: 'PR', name: 'Puerto Rico'},
  {code: 'PS', name: 'Palästina'},
  {code: 'PT', name: 'Portugal'},
  {code: 'PW', name: 'Palau'},
  {code: 'PY', name: 'Paraguay'},
  {code: 'QA', name: 'Qatar'},
  {code: 'RE', name: 'Reunion'},
  {code: 'RO', name: 'Rumänien'},
  {code: 'RS', name: 'Serbien'},
  {code: 'RU', name: 'Russland'},
  {code: 'RW', name: 'Ruanda'},
  {code: 'SA', name: 'Saudi Arabien'},
  {code: 'SB', name: 'Solomon Inseln'},
  {code: 'SC', name: 'Seychellen'},
  {code: 'SD', name: 'Sudan'},
  {code: 'SE', name: 'Schweden'},
  {code: 'SG', name: 'Singapur'},
  {code: 'SH', name: 'St. Helena'},
  {code: 'SI', name: 'Slowenien'},
  {code: 'SJ', name: 'Svalbard und Jan Mayen Islands'},
  {code: 'SK', name: 'Slowakei -slowakische Republik-'},
  {code: 'SL', name: 'Sierra Leone'},
  {code: 'SM', name: 'San Marino'},
  {code: 'SN', name: 'Senegal'},
  {code: 'SO', name: 'Somalia'},
  {code: 'SR', name: 'Surinam'},
  {code: 'SS', name: 'Südsudan'},
  {code: 'ST', name: 'Sao Tome'},
  {code: 'SV', name: 'El Salvador'},
  {code: 'SX', name: 'Sint Maarten'},
  {code: 'SY', name: 'Syrien'},
  {code: 'SZ', name: 'Swasiland'},
  {code: 'TC', name: 'Turks und Kaikos Inseln'},
  {code: 'TD', name: 'Tschad'},
  {code: 'TF', name: 'Französisches Süd-Territorium'},
  {code: 'TG', name: 'Togo'},
  {code: 'TH', name: 'Thailand'},
  {code: 'TJ', name: 'Tadschikistan'},
  {code: 'TK', name: 'Tokelau'},
  {code: 'TL', name: 'Osttimor'},
  {code: 'TM', name: 'Turkmenistan'},
  {code: 'TN', name: 'Tunesien'},
  {code: 'TO', name: 'Tonga'},
  {code: 'TR', name: 'Türkei'},
  {code: 'TT', name: 'Trinidad und Tobago'},
  {code: 'TV', name: 'Tuvalu'},
  {code: 'TW', name: 'Taiwan'},
  {code: 'TZ', name: 'Tansania'},
  {code: 'UA', name: 'Ukraine'},
  {code: 'UG', name: 'Uganda'},
  {code: 'UM', name: 'United States Minor Outlying Islands'},
  {code: 'US', name: 'Vereinigte Staaten von Amerika'},
  {code: 'UY', name: 'Uruguay'},
  {code: 'UZ', name: 'Usbekistan'},
  {code: 'VA', name: 'Vatikan'},
  {code: 'VC', name: 'St. Vincent'},
  {code: 'VE', name: 'Venezuela'},
  {code: 'VG', name: 'Virgin Island (Brit.)'},
  {code: 'VI', name: 'Virgin Island (USA)'},
  {code: 'VN', name: 'Vietnam'},
  {code: 'VU', name: 'Vanuatu'},
  {code: 'WF', name: 'Wallis und Futuna'},
  {code: 'WS', name: 'Samoa'},
  {code: 'YE', name: 'Jemen'},
  {code: 'YT', name: 'Mayotte'},
  {code: 'ZA', name: 'Südafrika'},
  {code: 'ZM', name: 'Sambia'},
  {code: 'ZW', name: 'Zimbabwe'},
];

export default countries;
